export const ItemQuestionnaire = {
	questionText: '',
	duration: 2,
};
